module.exports = __webpack_public_path__ + "ppt.2ced461ce022a3ced63d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/assets/icon/ppt.svg
// module id = ../../../../../src/assets/icon/ppt.svg
// module chunks = main